module.exports = __webpack_public_path__ + "static/img/bg_media.ef8bf25b.jpg";